import { AuthPage } from '@refinedev/antd';
import { AppTitle } from '@/components/common/AppTitle';

export const LoginPage = () => {
  return (
    <AuthPage
      type="login"
      rememberMe={false}
      registerLink={false}
      forgotPasswordLink={false}
      formProps={{
        initialValues: {
          username: '',
          password: '',
        },
      }}
      title={<AppTitle collapsed={false} />}
    />
  );
};
